import AsyncComponent from 'utils/asyncComponent';

export const Login = AsyncComponent(() => import('./Login'));
export const Join = AsyncComponent(() => import('./Join'));
export const Find = AsyncComponent(() => import('./Find'));
export const List = AsyncComponent(() => import('./List'));
export const View = AsyncComponent(() => import('./View'));
export const Create = AsyncComponent(() => import('./Create'));
export const Viewer = AsyncComponent(() => import('./Viewer'));
export const Setting = AsyncComponent(() => import('./Setting'));